// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3AiTq","description":"PatientConsentPreview_description__3l1w_"};